import {IDataLayer} from "../app";
import parseHTML from "./dom/funciones/parse_html";
import acordeon from "./aria/acordeon";

interface OpcionesCookies {
    texto: string,
    aceptar: string,
    rechazar: string,
    configurar: string,
    bloquear: boolean,
    siempreHabilitado: string,
    mostrarRechazar: boolean,
    aceptadas: string,
    rechazadas: string,
    tituloConsentimiento: string,
    textoEstado: string,
    cambiarConfiguracion: string,
    guardarConfiguracion: string,
    aceptarTodas: string,
    configuracion: {
        mensaje: string,
        tipos: [{
            nombre: string,
            obligatorio: boolean,
            consentimiento: string,
            descripcion: string,
        }]
    }
}

// Array of callbacks to be executed when consent changes
let pendientes: any[] = [];

// Array of callbacks to be executed when consent changes
const consentListeners: any[] = [];

(window as any).addConsentListener = (callback: any) => {
    pendientes.forEach((consent) => callback(consent));
    consentListeners.push(callback);
};

/**
 * Called when user grants/denies consent.
 * @param {Object} Object containing user consent settings.
 */
const onConsentChange = (consent: any) => {
    document.cookie = `cookie_consent=${JSON.stringify(consent)};path=/;max-age=31536000`;

    if (consentListeners.length === 0) {
        pendientes.push(consent);
    } else {
        consentListeners.forEach((callback) => callback(consent));
    }
};

const popup = parseHTML<HTMLDivElement>(`<div class="popup-cookies" role="banner">
    <div class="inner">
        <div class="popup-cookies__texto">
            Utilizamos cookies propias y de terceros para mejorar nuestros servicios.
            Si haces clic en ACEPTAR, consideramos que aceptas su uso.
            Puedes obtener más información en la 
            <a href="/condiciones-de-uso/" target="_blank">Política de cookies</a>.
        </div>
        <div class="popup-cookies__botones">
            <button class="popup-cookies__aceptar">
                Aceptar
            </button>
            <button class="popup-cookies__configurar">
                Configurar
            </button>
            <button class="popup-cookies__rechazar">
                Rechazar
            </button>
        </div>
    </div>
</div>`);

const ocultar = () => {
    popup.classList.remove('is-visible');
};

const creaConfiguracion = (opciones: OpcionesCookies, configuracion: any, onAceptar: (opciones: any) => void) => {
    const popup = parseHTML(`<div class="popup-cookies__configuracion" role="dialog">
        <form class="inner">
            <div class="popup-cookies__configuracion__texto">
                ${opciones.configuracion.mensaje}
            </div>

            <div class="popup-cookies__configuracion__botones">
                <button class="popup-cookies__configuracion__guardar" type="button">
                    ${opciones.guardarConfiguracion}
                </button>
                <button class="popup-cookies__configuracion__aceptar" type="button">
                    ${opciones.aceptarTodas}
                </button>
            </div>

            <div class="popup-cookies__configuracion__tipos">
            ${opciones.configuracion.tipos.map((tipo, i) => `
                <div class="popup-cookies__configuracion__tipo">
                    <div class="popup-cookies__configuracion__tipo__nombre">
                        <div>
                            <button aria-controls="cookies-${i}" type="button" aria-expanded="false">${tipo.nombre}</button>
                        </div>
                        <div>
                            ${tipo.obligatorio ? opciones.siempreHabilitado : `<input type="checkbox" name="${tipo.consentimiento}" ${configuracion[tipo.consentimiento] ? 'checked' : ''}>`}
                        </div>
                    </div>
                    <div class="popup-cookies__configuracion__tipo__descripcion" id="cookies-${i}" hidden>
                        <div class="inner">${tipo.descripcion}</div>
                    </div>
                </div>
            `).join('')}
            </div>
        </form>
    </div>`);

    const
        form = popup.querySelector('form') as HTMLFormElement,
        guardar = popup.querySelector('.popup-cookies__configuracion__guardar') as HTMLButtonElement,
        aceptar = popup.querySelector('.popup-cookies__configuracion__aceptar') as HTMLButtonElement;

    acordeon(popup, false);

    guardar.addEventListener('click', () => {
        onAceptar(
            opciones.configuracion.tipos.filter(x => x.consentimiento).reduce((acc, tipo) => {
                const input = form.querySelector('input[name="' + tipo.consentimiento + '"]') as HTMLInputElement;
                return ({
                    ...acc,
                    [tipo.consentimiento]: input ? input.checked : true
                });
            }, {} as { [key: string]: boolean })
        );
    });

    aceptar.addEventListener('click', () => {
        onAceptar(
            opciones.configuracion.tipos.filter(x => x.consentimiento).reduce((acc, tipo) => {
                return ({
                    ...acc,
                    [tipo.consentimiento]: true
                });
            }, {} as { [key: string]: boolean })
        );
    });

    return popup;
}

const muestraValoresElegidos = (opciones: OpcionesCookies) => {
    const contenedor = document.querySelector('.configuracion-cookies') as HTMLElement;

    if (!contenedor) {
        return;
    }

    const descripciones = Object.keys(opciones.configuracion.tipos).reduce((acc, key) => ({
        ...acc,
        [opciones.configuracion.tipos[key].consentimiento]: opciones.configuracion.tipos[key].nombre
    }), {} as { [key: string]: boolean } as any)

    const configuracion = localStorage.configuracion ? JSON.parse(localStorage.configuracion) : {};
    const permitidas = Object.keys(configuracion).filter(key => configuracion[key]);
    const rechazadas = Object.keys(configuracion).filter(key => !configuracion[key]);

    if (permitidas.length === 0) {
        permitidas.push('functionality_storage');
    }

    let html = '<h2>' + opciones.tituloConsentimiento + '</h2><p> ' + opciones.textoEstado + ': ';

    const nombresPermitidas = permitidas.map(x => descripciones[x]).filter(x => x !== undefined);
    const nombresRechazadas = rechazadas.map(x => descripciones[x]).filter(x => x !== undefined);

    if (nombresPermitidas.length) {
        html += opciones.aceptadas + ': ' + nombresPermitidas.join(', ') + '. ';
    }

    if (nombresRechazadas.length) {
        html += opciones.rechazadas + ': ' + nombresRechazadas.join(', ') + '.';
    }
    html += '</p>';

    html += '<p><button onclick="window.mostrarCookies()">' + opciones.cambiarConfiguracion + '</button></p>';

    contenedor.innerHTML = html;
}

const cookies = (dataLayer: IDataLayer, opciones?: OpcionesCookies) => {
    const aceptar = popup.querySelector('.popup-cookies__aceptar') as HTMLButtonElement,
        rechazar = popup.querySelector('.popup-cookies__rechazar') as HTMLButtonElement,
        configurar = popup.querySelector('.popup-cookies__configurar') as HTMLButtonElement,
        texto = popup.querySelector('.popup-cookies__texto') as HTMLDivElement,
        cambiaConfiguracion = (configuracion: any) => {
            localStorage.fechaDeConfiguracion = Date.now().toString();
            localStorage.configuracion = JSON.stringify(configuracion);

            onConsentChange(configuracion);

            ocultar();
            muestraValoresElegidos(opciones);
        },
        configuracion = localStorage.configuracion ? JSON.parse(localStorage.configuracion) : {},
        tipos = (aceptado: boolean) => Object.keys(opciones.configuracion.tipos).reduce((acc, key) => ({
            ...acc,
            [opciones.configuracion.tipos[key].consentimiento]: aceptado
        }), {} as { [key: string]: boolean } as any),
        fecha = parseInt(localStorage.getItem('fechaDeConfiguracion') || '0'),
        popupConfiguracion = creaConfiguracion(opciones!, configuracion, configuracion => {
            cambiaConfiguracion(configuracion);
            popupConfiguracion.classList.remove('is-visible');
        }),
        aceptaTodo = () => cambiaConfiguracion(tipos(true)),
        rechazaTodo = () => cambiaConfiguracion({
            ...tipos(false),
            functionality_storage: true
        }),
        muestraConfiguracion = () => {
            document.documentElement.appendChild(popupConfiguracion);
            popupConfiguracion.classList.add('is-visible');
            popup.classList.remove('is-visible');
        };

    if (opciones) {
        texto.innerHTML = opciones?.texto || texto.innerHTML;
        aceptar.innerHTML = opciones.aceptar;
        rechazar.innerHTML = opciones.rechazar;
        configurar.innerHTML = opciones.configurar;

        if (opciones.bloquear) {
            popup.classList.add('popup-cookies--bloquear');
        }

        if (!opciones.mostrarRechazar) {
            rechazar.remove();
        }
    }


    aceptar.addEventListener('click', aceptaTodo);
    rechazar.addEventListener('click', rechazaTodo);
    configurar.addEventListener('click', muestraConfiguracion);

    // Si no se ha aceptado o rechazado, mostrar el popup
    document.documentElement.appendChild(popup);
    document.documentElement.appendChild(popupConfiguracion);

    window.mostrarCookies = () => popup.classList.add('is-visible');

    if (document.querySelector('.configuracion-cookies')) {
        muestraValoresElegidos(opciones);
        return;
    }

    if (Object.keys(configuracion).length > 0) {
        onConsentChange(configuracion);
        return;
    }

    // Si hace menos de 6 meses que se configuró, no mostrar el popup
    if (Object.keys(configuracion).length > 0 && fecha > Date.now() - 15768000000) {
        return;
    }

    setTimeout(window.mostrarCookies);
};

export default cookies;